import graphql from "babel-plugin-relay/macro";

export const CustomerLogoQuery = graphql`
  query CustomerLogoQuery {
    currentTenant {
      customerLogo
    }
  }
`;
